import * as Yup from 'yup'

import { createFields } from '../helpers/createFields'
import { toBoolean } from '../helpers/toBoolean'
import { buildValidationSchema } from '../yup/buildValidationSchema'

const fields = (currentKeys?: string[]) =>
  createFields({
    wishesAndExpectations: {
      __type: 'custom',
      label: 'any',
      validation: Yup.array().of(
        Yup.object()
          .shape({
            key: Yup.string().required(),
            flag: Yup.boolean(),
            score: Yup.number().nullable(),
            required: Yup.boolean(),
          })
          .test('what-is-important-score', 'error', function (value) {
            return !(value.key === 'what_is_important' && currentKeys?.includes('what_is_important') && !value.score)
          })
      ),
      name: 'wishesAndExpectations',
    },
    isPregnant: {
      __type: 'radioGroup',
      label: 'field.are_you_pregnant',
      name: 'isPregnant',
      helperText: 'field.is_pregnant_helper',
      isRequired: true,
      options: [
        {
          label: 'yes',
          value: 'true',
        },
        {
          label: 'no',
          value: 'false',
        },
      ],
      inputProps: {
        withText: true,
      },
      validation: Yup.boolean().when('gender', (gender) =>
        gender === 'MALE' ? Yup.boolean() : Yup.boolean().required()
      ),
      visibleWhen: ({ gender }) => gender !== 'MALE',
      hooks: {
        beforeChange: (value, { setFieldValue }, _event) => {
          if (!toBoolean(value)) {
            setFieldValue('pregnantMonths', undefined)
          }
        },
      },
    },
    pregnantMonths: {
      __type: 'select',
      label: 'field.pregnant_month',
      name: 'pregnantMonths',
      isRequired: true,
      inputProps: {
        type: 'number',
      },
      options: Array.from({ length: 9 }).map((_, index) => ({ value: String(index + 1), label: String(index + 1) })),
      validation: Yup.number()
        .min(0)
        .max(9)
        .when('isPregnant', {
          is: true,
          then: Yup.number().required('field.pregnant_months_error'),
          otherwise: Yup.number(),
        }),
      visibleWhen: ({ isPregnant }) => {
        return toBoolean(isPregnant)
      },
    },
  })

export const validationSchema = (currentKeys: string[]) => buildValidationSchema(fields(currentKeys))

export default fields
